// @flow

import type { FirstCareIndexState } from "./types";

export const initialState: FirstCareIndexState = {
  error: null,
  requestsInProgress: 0,
  absenceTotalsReport: null,
  absenceTrendsReport: null,
};

export default initialState;
